import { ReactNode, createContext, useContext } from "react";
import { useSphereRedeemItem } from "./sphere-redeem-item.hook";

const SphereRedeemItemCtx = createContext(
  {} as ReturnType<typeof useSphereRedeemItem>
);
export function useSphereRedeemItemCtx() {
  return useContext(SphereRedeemItemCtx);
}

interface SphereRedeemItemProviderProps {
  children: ReactNode;
}
export function SphereRedeemItemProvider({
  children,
}: SphereRedeemItemProviderProps) {
  return (
    <SphereRedeemItemCtx.Provider value={useSphereRedeemItem()}>
      {children}
    </SphereRedeemItemCtx.Provider>
  );
}
